<template>
  <div
    v-if="visible"
    ref="notice"
    class="demo-environment-notice"
    :style="noticeStyle"
    @mousedown="startDrag"
    @touchstart="startDrag"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'DemoEnvironmentNotice',

  data: () => ({
    dragging: false,
    offsetX: 0,
    offsetY: 0,
    left: null,
    top: null,
    bottom: 12,
  }),

  computed: {
    visible() {
      return ['test', 'demo'].includes(String(process.env.VUE_APP_CHANNEL).toLowerCase());
    },

    brand() {
      return String(process.env.VUE_APP_ENV).toUpperCase().startsWith('EBI') ? 'EBIPAC' : 'HKA';
    },

    message() {
      return `Ambiente demostrativo ${this.brand} sin valor fiscal.`;
    },

    noticeStyle() {
      const style = {
        position: 'fixed',
        zIndex: 1000,
      };

      if (this.top !== null) {
        style.top = `${this.top}px`;
        style.bottom = 'auto';
      } else {
        style.bottom = `${this.bottom}px`;
        style.top = 'auto';
      }

      if (this.left !== null) {
        style.left = `${this.left}px`;
        style.right = 'auto';
        style.transform = 'none';
      } else {
        style.left = '50%';
        style.right = 'auto';
        style.transform = 'translateX(-50%)';
      }

      return style;
    },
  },

  mounted() {
    if (!this.visible) {
      return;
    }

    // Evita que un contenedor con transform afecte position:fixed
    if (this.$refs.notice && this.$refs.notice.parentNode !== document.body) {
      document.body.appendChild(this.$refs.notice);
    }

    document.addEventListener('mousemove', this.drag);
    document.addEventListener('mouseup', this.stopDrag);
    document.addEventListener('touchmove', this.drag, { passive: false });
    document.addEventListener('touchend', this.stopDrag);
  },

  beforeDestroy() {
    document.removeEventListener('mousemove', this.drag);
    document.removeEventListener('mouseup', this.stopDrag);
    document.removeEventListener('touchmove', this.drag);
    document.removeEventListener('touchend', this.stopDrag);

    if (this.$refs.notice && this.$refs.notice.parentNode === document.body) {
      document.body.removeChild(this.$refs.notice);
    }
  },

  methods: {
    getPoint(event) {
      return event.touches ? event.touches[0] : event;
    },

    startDrag(event) {
      const point = this.getPoint(event);
      const rect = this.$refs.notice.getBoundingClientRect();

      this.dragging = true;
      this.offsetX = point.clientX - rect.left;
      this.offsetY = point.clientY - rect.top;
      this.left = rect.left;
      this.top = rect.top;
      this.bottom = null;
      event.preventDefault();
    },

    drag(event) {
      if (!this.dragging) {
        return;
      }

      const point = this.getPoint(event);
      const notice = this.$refs.notice;
      const maxLeft = window.innerWidth - notice.offsetWidth;
      const maxTop = window.innerHeight - notice.offsetHeight;

      this.left = Math.min(Math.max(point.clientX - this.offsetX, 0), maxLeft);
      this.top = Math.min(Math.max(point.clientY - this.offsetY, 0), maxTop);
      event.preventDefault();
    },

    stopDrag() {
      this.dragging = false;
    },
  },
};
</script>

<style>
.demo-environment-notice {
  padding: 8px 12px;
  border-radius: 4px;
  background: #ffff00 !important;
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: move;
  user-select: none;
  opacity: 0.8;
  max-width: calc(100vw - 24px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
</style>
